import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { epicObs } from '../../../store';
import { CmpsCoachingWinningPercentageModule } from '../winning-percentage';

import { FlWinningGridComponent } from './fl-winning-grid.component';
import { TranslationIdMap } from './fl-winning.i18n';
import { CmpsFLWinningModule } from './fl-winning.module';
import { mainEpics } from './main/main.epic';
import { FLWinningService } from './services/fl-winning.service';

@NgModule({
    declarations: [FlWinningGridComponent],
    exports: [FlWinningGridComponent],
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsButtonModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CmpsFLWinningModule,
        CmpsCoachingWinningPercentageModule,
    ],
    providers: [FLWinningService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsFLWinningMainModule {
    constructor() {
        mainEpics.forEach((e) => epicObs.next(e));
    }
}
